import React, { useState } from 'react';
import products from '../../api/products.json';

const AllProducts = () => {
    const [searchId, setSearchId] = useState('');
    const [searchName, setSearchName] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');

    const filteredProducts = products.filter(product => 
        product && 
        product.id && 
        product.id.toString().includes(searchId) &&
        (!searchName || product.name.toLowerCase().includes(searchName.toLowerCase())) &&
        (!selectedCategory || product.category === selectedCategory)
    );

    return (
        <div style={{ padding: '10px' }}>
            <h1 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Сите продукти</h1>
            
            <div style={{ marginBottom: '20px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                <input
                    type="text"
                    placeholder="шифра на производ"
                    value={searchId}
                    onChange={(e) => setSearchId(e.target.value)}
                    style={{
                        padding: '8px',
                        fontSize: '14px',
                        width: '90%',
                        maxWidth: '300px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                />
                <input
                    type="text"
                    placeholder="назив на производ"
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                    style={{
                        padding: '8px',
                        fontSize: '14px',
                        width: '90%',
                        maxWidth: '300px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                />
                <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    style={{
                        padding: '8px',
                        fontSize: '14px',
                        width: '90%',
                        maxWidth: '300px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                >
                    <option value="">Сите категории</option>
                    {Array.from(new Set(products.map(product => product && product.category).filter(Boolean))).map((category) => (
                        <option key={category} value={category}>{category}</option>
                    ))}
                </select>
            </div>

            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f2f2f2', borderBottom: '2px solid #ddd' }}>
                            <th style={{ fontSize: '16px', fontWeight: 'bold', padding: '10px', border: '1px solid #ddd' }}>шифра на производ</th>
                            <th style={{ fontSize: '16px', fontWeight: 'bold', padding: '10px', border: '1px solid #ddd' }}>назив на производ</th>
                            <th style={{ fontSize: '16px', fontWeight: 'bold', padding: '10px', border: '1px solid #ddd' }}>категорија</th>
                            <th style={{ fontSize: '16px', fontWeight: 'bold', padding: '10px', border: '1px solid #ddd' }}>цена</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredProducts.map((product, index) => (
                            product && <tr key={product.id} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9', borderBottom: '1px solid #ddd' }}>
                                <td className='product-id' style={{ fontSize: '14px', padding: '10px', border: '1px solid #ddd' }}>{product.id}</td>
                                <td className='product-name' style={{ fontSize: '14px', padding: '10px', border: '1px solid #ddd' }}>{product.name}</td>
                                <td className='product-category' style={{ fontSize: '14px', padding: '10px', border: '1px solid #ddd' }}>{product.category}</td>
                                <td className='product-price' style={{ fontSize: '14px', padding: '10px', border: '1px solid #ddd' }}>
                                    {
                                    !isNaN(product.price) && parseFloat(product.price).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'MKD'
                                    }).replace('MKD', 'ден.')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllProducts;
